const PREFIX = 'lumen-arcade:';

export function loadJson<T>(key: string, fallback: T): T {
  try {
    const raw = localStorage.getItem(PREFIX + key);
    if (!raw) return fallback;
    return JSON.parse(raw) as T;
  } catch {
    return fallback;
  }
}

export function saveJson(key: string, value: unknown) {
  try {
    localStorage.setItem(PREFIX + key, JSON.stringify(value));
  } catch {
    /* quota / private mode */
  }
}

export function bestScore(id: string): number {
  return loadJson<number>(`${id}:best`, 0);
}

export function writeBest(id: string, score: number): number {
  const next = Math.max(bestScore(id), score);
  saveJson(`${id}:best`, next);
  return next;
}

export interface Settings {
  muted: boolean;
  volume: number;
  music: boolean;
}

export function loadSettings(): Settings {
  return loadJson<Settings>('settings', { muted: false, volume: 0.7, music: true });
}

export function saveSettings(s: Settings) {
  saveJson('settings', s);
}
